// extracted by mini-css-extract-plugin
export default {"tab":"GameOnboardingInstruction_tab__IIaN9","tab-panel":"GameOnboardingInstruction_tab-panel__p9oF2"};